<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto">
      <div v-if="loader" class="flex flex-col justify-center items-center py-12">
        <svg class="animate-spin h-10 w-10 text-emerald-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-slate-500 font-medium">Carregando relatório...</span>
      </div>
      <ConferenceAll
        v-else
        id="conferenceList"
        :data="dataReport"
        :filter="filter"
        :prefecture="prefecture"
        :provider="provider"
        ref="allComponent"
      />
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import ConferenceAll from "../impressions/conference";
export default {
  components: { ConferenceAll },
  mixins: [Helpers],
  props: {
    endDate: null,
    startDate: null,
    provider_id: null,
    prefecture_id: null,
    vehicle_id: null,
  },
  data: () => ({
    dataReport: [],
    filter: {},
    prefecture: [],
    provider: [],
    loader: false,
  }),
  created() {
    this.loadReportConferences();
    this.Helpers;
  },
  methods: {
    loadReportConferences() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      (this.filter = {
        endDate: this.endDate,
        startDate: this.startDate,
        provider_id: this.provider_id,
        prefecture_id: this.prefecture_id,
        vehicle_id: this.vehicle_id,
      }),
        this.$http
          .post(`/supplies/period/conferences`, this.filter)
          .then((r) => {
            this.$http
              .get(`/prefectures/${this.filter.prefecture_id}`)
              .then((p) => {
                this.prefecture = p.data[0];
                this.$http
                  .get(`/providers/${this.filter.provider_id}`)
                  .then((pp) => {
                    this.provider = pp.data[0];
                    // Filtrar rigorosamente secretarias e veículos para eliminar abastecimentos extras não distribuídos
                    const rawSecs = r.data && r.data.secretariats ? r.data.secretariats : [];
                    const filteredSecs = [];

                    rawSecs.forEach(sec => {
                      const secNameUpper = (sec.sec_name || "").toUpperCase();
                      if (secNameUpper.includes("GERAL / NÃO INFORMADO") || secNameUpper.includes("NÃO INFORMADO")) {
                        return;
                      }

                      const validVehicles = (sec.vehicles || []).filter(v => {
                        if (!v.vehicle_id || v.vehicle_id === 0 || v.vehicle_id === "0") return false;
                        if (!v.vehicle_board || v.vehicle_board === "---" || v.vehicle_board === "-") return false;
                        
                        if (v.supplies && v.supplies.length > 0) {
                          v.supplies = v.supplies.filter(s => !s.supply_extra);
                          if (v.supplies.length === 0) return false;
                          v.totalLiters = v.supplies.reduce((acc, s) => acc + Number(s.supply_liters_stocked || 0), 0);
                          v.totalValue = v.supplies.reduce((acc, s) => acc + Number(s.supply_bidding_value || 0), 0);
                          v.totalValueDay = v.supplies.reduce((acc, s) => acc + Number(s.supply_value || 0), 0);
                        }
                        return true;
                      });

                      if (validVehicles.length > 0) {
                        const secLiters = validVehicles.reduce((acc, v) => acc + Number(v.totalLiters || 0), 0);
                        const secValue = validVehicles.reduce((acc, v) => acc + Number(v.totalValue || 0), 0);
                        const secValueDay = validVehicles.reduce((acc, v) => acc + Number(v.totalValueDay || 0), 0);

                        filteredSecs.push({
                          ...sec,
                          vehicles: validVehicles,
                          totalLiters: secLiters,
                          totalValue: secValue,
                          totalValueDay: secValueDay
                        });
                      }
                    });

                    const finalTotals = {
                      totalFinalLiters: 0,
                      totalFinalValuesBilling: 0,
                      totalTypes: [
                        { name: "ÓLEO DIESEL S10", liters: 0, valueBilling: 0, valueDay: 0, item_billing_price: 0, supply_bidding_price: 0, supply_price_day: 0 },
                        { name: "GASOLINA COMUM", liters: 0, valueBilling: 0, valueDay: 0, item_billing_price: 0, supply_bidding_price: 0, supply_price_day: 0 },
                        { name: "GASOLINA ADITIVADA", liters: 0, valueBilling: 0, valueDay: 0, item_billing_price: 0, supply_bidding_price: 0, supply_price_day: 0 },
                        { name: "ÓLEO DIESEL S500", liters: 0, valueBilling: 0, valueDay: 0, item_billing_price: 0, supply_bidding_price: 0, supply_price_day: 0 },
                        { name: "ETANOL COMUM", liters: 0, valueBilling: 0, valueDay: 0, item_billing_price: 0, supply_bidding_price: 0, supply_price_day: 0 },
                      ]
                    };

                    filteredSecs.forEach(sec => {
                      sec.vehicles.forEach(veh => {
                        (veh.supplies || []).forEach(s => {
                          const lit = Number(s.supply_liters_stocked || 0);
                          const valBilling = Number(s.supply_bidding_value || 0);
                          const valDay = Number(s.supply_value || 0);
                          const biddingPrice = Number(s.supply_bidding_price || 0);
                          const priceDay = Number(s.supply_price_day || 0);

                          const tt = finalTotals.totalTypes.find(t => t.name === s.item_description_desc);
                          if (tt) {
                            tt.liters += lit;
                            tt.valueBilling += valBilling;
                            tt.valueDay += valDay;
                            tt.item_billing_price = biddingPrice || tt.item_billing_price;
                            tt.supply_bidding_price = biddingPrice || tt.supply_bidding_price;
                            tt.supply_price_day = priceDay || tt.supply_price_day;
                          }
                        });
                      });
                    });

                    finalTotals.totalTypes.forEach(tt => {
                      finalTotals.totalFinalLiters += Number(tt.liters || 0);
                      finalTotals.totalFinalValuesBilling += Number(tt.valueBilling || 0);
                    });

                    this.dataReport = {
                      secretariats: filteredSecs,
                      finalTotals
                    };
                    this.showConferencePageOne = true;
                    this.loader = false;
                    this.$store.dispatch("setLoader", this.loader);
                  });
              });
          });
    },
  },
};
</script>

<style>
</style>